/* tslint:disable */
/* eslint-disable */
/**
 * AGAIN-AGAIN API
 * backend api for tracking container movement for again-again
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NFCTag,
    NFCTagFromJSON,
    NFCTagFromJSONTyped,
    NFCTagToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReturnContainer
 */
export interface ReturnContainer {
    /**
     * 
     * @type {string}
     * @memberof ReturnContainer
     */
    shelfId: string;
    /**
     * 
     * @type {NFCTag}
     * @memberof ReturnContainer
     */
    tag: NFCTag;
}

export function ReturnContainerFromJSON(json: any): ReturnContainer {
    return ReturnContainerFromJSONTyped(json, false);
}

export function ReturnContainerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReturnContainer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'shelfId': json['shelf_id'],
        'tag': NFCTagFromJSON(json['tag']),
    };
}

export function ReturnContainerToJSON(value?: ReturnContainer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'shelf_id': value.shelfId,
        'tag': NFCTagToJSON(value.tag),
    };
}


